// this is an autogenerated file from DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/EditLetterAction/query-document-node-id.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_GenerateLettersModal_Content_Letters_Letter_Actions_EditLetterAction($_id: uuid!) {
  vaxiom_document_tree_nodes(where: { _id: { _eq: $_id } }) {
    id
  }
}

`